import { useMemo } from 'preact/hooks';

import { html, nothing } from '@shared/utils/rendering/html';

import Table from '@shared/components/tables';

import { UserColumns } from '@core/configs/admin/users/users-table.config';

import UsersTableActions from './users-table.actions';
import { useUserData } from './hooks/use-user-data';
import { useUserFilter } from './hooks/use-user-filter';

export default function UsersTable() {
    const { requestParams, tableFilters } = useUserFilter();
    const { tableData } = useUserData(requestParams);

    const config = useMemo(() => {
        return {
            columns: UserColumns,
            filters: tableFilters,
            actions: UsersTableActions,
        };
    }, [tableFilters]);

    return config
        ? html` <div class="card"><${Table} config=${config} data=${tableData} /></div>`
        : nothing;
}
